import { forwardRef } from "react";
import styled, { css } from "styled-components/macro";
import { Link, LinkProps as untypedLinkProps } from "react-router-dom";

import { ActionType } from "utils/analytics/analyticsConstants";
import { useAnalytics } from "utils/analytics/AnalyticsContext";
import { AnalyticsProps } from "utils/analytics/AnalyticsProps";

type LinkProps = untypedLinkProps & {
  styled?: boolean;
};

export interface UILinkProps extends LinkProps, AnalyticsProps {}

const $Link = styled(Link)<{ $styled?: boolean }>`
  text-decoration: none;
  color: ${({ theme }) => theme.ColorWhite};
  ${(props) =>
    props.$styled &&
    css`
      color: inherit;
      text-decoration: underline;
      &:hover,
      &:active,
      &:focus {
        color: ${({ theme }) => theme.ColorBlurple500};
      }
    `};
`;

const UILink = forwardRef<HTMLAnchorElement, UILinkProps>((props, ref) => {
  const {
    analyticsName,
    analyticsSurface,
    analyticsProperties,
    analyticsType,
    onClick,
    children,
    styled,
    ...restProps
  } = props;

  const { trackEvent } = useAnalytics("NavLink " + analyticsName);

  return (
    <$Link
      $styled={styled}
      {...restProps}
      onClick={(event) => {
        trackEvent({
          eventName: analyticsName,
          eventType: analyticsType || ActionType.CLICK_LINK,
          analyticsSurface,
          extraProperties: analyticsProperties,
        });

        if (onClick) {
          onClick(event);
        }
      }}
      ref={ref}
    >
      {children}
    </$Link>
  );
});

UILink.displayName = "Link";

export default UILink;
